import(/* webpackMode: "eager", webpackExports: ["CategoryTag"] */ "/workspace/src/components/atom/categoryTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/workspace/src/components/moleculer/wrapper.tsx");
